export enum OpenLevelNameEnum {
  "公開" = "公開",
  "社内" = "社内",
  "支店内" = "支店内",
  "プライベート" = "プライベート"
}
